<template>
  <b-card>
    <form-component :shop="shop" @onSubmit="onSubmit" />
  </b-card>
</template> 

<script>
import FormComponent from '@/components/shops/FormComponent';
import NotificationMixin from '@/mixins/NotificationMixin';
import { show, update } from '@/http/shops';

export default {
  mixins: [NotificationMixin],
  components: {
    FormComponent,
  },

  data() {
    return {
      shop: {
        name: '',
        county: '',
        category: '',
        address_city: '',
        address_street: '',
        address_number: '',
        address_local_number: '',
        postal_code: '',
        latitude: '',
        longitude: '',
        country: null,
        should_update: false,
        link_1: '',
        is_official: false,
        is_online: false,
      },
    };
  },

  async mounted() {
    await this.fetchShop();
  },

  methods: {
    async fetchShop() {
      try {
        const { data } = await show(this.$route.params.id);

        this.shop.name = data.data.name;
        this.shop.county = data.data.county;
        this.shop.category = data.data.category;
        this.shop.address_city = data.data.address_city;
        this.shop.address_street = data.data.address_street;
        this.shop.address_number = data.data.address_number;
        this.shop.address_local_number = data.data.address_local_number;
        this.shop.postal_code = data.data.postal_code;
        this.shop.latitude = data.data.geo_location.latitude;
        this.shop.longitude = data.data.geo_location.longitude;
        this.shop.should_update = data.data.should_update;
        this.shop.link_1 = data.data.link_1;
        this.shop.is_official = data.data.is_official;
        this.shop.is_online = data.data.is_online;
        // Convert full country name to country code if needed
        const countryValue = data.data.country;
        this.shop.country = this.getCountryCode(countryValue);

      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił błąd podczas pobierania sklepu. Skontaktuj się ze swoim developerem.',
        );
      }
    },

    getCountryCode(countryValue) {
      if (countryValue === 'UA' || countryValue === 'PL') {
        return countryValue;
      }
      
      // If the API returns full country names
      if (countryValue?.toLowerCase().includes('polsk')) {
        return 'PL';
      } else if (countryValue?.toLowerCase().includes('ukrai')) {
        return 'UA';
      }
      
      return null;
    },

    async onSubmit(form) {
      try {
        const payload = {
          name: form.name,
          county: form.county,
          category: form.category,
          address_city: form.address_city,
          address_street: form.address_street,
          address_number: form.address_number,
          address_local_number: form.address_local_number,
          postal_code: form.postal_code,
          longitude: form.longitude,
          latitude: form.latitude,
          country: form.country,
          should_update: form.should_update,
          link_1: form.link_1,
          is_official: form.is_official,
          is_online: form.is_online,
        };

        await update(this.$route.params.id, payload);

        this.showSuccessNotification('Dane zapisane', 'Sklep został zaktualizowany.');
        this.$router.push({ name: 'shops-index' });
      } catch (error) {
        const message =
          error.response?.data?.message ??
          'Wystąpił błąd podczas edycji sklepu. Skontaktuj się ze swoim developerem.';
        this.showErrorNotification('Problem z zapisaniem danych', message);
      }
    },
  },
};
</script>
